module.exports = __webpack_public_path__ + "img/Voucher Icon - charcoal.c553855f.svg";